import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ListComponent } from './list/list.component';
import { ExportService } from './services/export.service';
import { ExportInvoicesComponent } from './export-invoices/export-invoices.component';
import { AppComponent } from '../app.component';
import { AuthGuard } from '../auth.guard';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/modules/shared.module';
import { routing } from './exports.routing';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule.forRoot(routing, {}),
        SharedModule,
    ],
    declarations: [ListComponent,
        ExportInvoicesComponent],
    exports: [],
    providers: [AppComponent, AuthGuard, ExportService]
})
export class ExportsModule { }
